import React from "react";
import Routes from "./routes/Routes";
import { Provider } from "react-redux";
import store from "./store/store";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "react-hot-toast";
import useApp from "./hooks/useApp";
import useApi from "./utils/useApi";
import PWAInstallPrompt from "./components/PWAInstallPrompt";

const AppContent = () => {
  const { callApi } = useApi();
  
  useApp();

  React.useEffect(() => {
    import('./services/NotificationService').then(async ({ NotificationService }) => {
      await NotificationService.requestWebPermission();
      const token = localStorage.getItem("token");
      if (token) {
        await NotificationService.registerWebToken(callApi);
      }
    });
  }, [callApi]);

  return (
    <>
      <Routes />
      <Toaster position="top-center" />
      <PWAInstallPrompt />
    </>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <AppContent />
      </Provider>
    </ThemeProvider>
  );
};

export default App;
